import { render, staticRenderFns } from "./LotteryView.vue?vue&type=template&id=053955e7"
import script from "./LotteryView.vue?vue&type=script&lang=js"
export * from "./LotteryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports